function whichTransitionEvent() {
  var el = document.createElement("fakeelement");
  var transitions = {
    transition: "transitionend",
    OTransition: "oTransitionEnd",
    MozTransition: "transitionend",
    WebkitTransition: "webkitTransitionEnd"
  };

  for (var t in transitions) {
    if (transitions.hasOwnProperty(t) && el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

export const prettyCollapse = (vueElement, direction) => {
  const element = vueElement.$el;
  const transitionEvent = whichTransitionEvent();
  const innerHeight = vueElement.$children.reduce(
    (acc, cur) => acc + cur.$el.offsetHeight,
    0
  );

  const open = () => {
    element.addEventListener(transitionEvent, function onTransitionEnd() {
      element.removeEventListener(transitionEvent, onTransitionEnd);
      element.style.height = "auto";
    });
    element.style.height = `${innerHeight}px`;
  };

  const close = () => {
    element.addEventListener(transitionEvent, function onTransitionEnd() {
      element.removeEventListener(transitionEvent, onTransitionEnd);
      element.style.height = 0;
    });

    element.style.height = `${innerHeight}px`;
    element.offsetHeight;
    element.style.height = 0;
  };

  if (direction === "close") {
    close();
  } else {
    open();
  }
};
